export const SUGGESTIONS_SUPPORT_LINK =
  'https://www.billy.dk/support/article/fa-styr-pa-din-moms-med-den-indbyggede-copilot/'
